import React, { useEffect, useState,useContext } from 'react';
import {
  Box, Typography, Grid, Chip, Card, CardContent, IconButton, Paper ,Container,Button, CircularProgress 
} from '@mui/material';
import { useLocation, useNavigate , useParams} from 'react-router-dom';
import axios from 'axios';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import BedIcon from '@mui/icons-material/Bed';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import BathtubIcon from '@mui/icons-material/Bathtub';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import BalconyIcon from '@mui/icons-material/Balcony';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import PowerIcon from '@mui/icons-material/Power';
import CropSquareOutlinedIcon from '@mui/icons-material/CropSquareOutlined';
import CompassCalibrationOutlinedIcon from '@mui/icons-material/CompassCalibrationOutlined';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import buildingImage from './../../../Images/house.jpeg';
import CustomBottomNav from './CustomBottomNav';
import { BASE_URL } from './../../Api/ApiUrls';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { AuthContext } from './../../AuthContext/AuthContext';
import CallIcon from '@mui/icons-material/Call';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Tooltip } from '@mui/material';
import CopyFailureAlert from '../Alertpage/CopyAlert/CopyFailureAlert';
import CopySuccessAlert from '../Alertpage/CopyAlert/CopySuccessAlert';

const Lease_description = () => { 
  const navigate = useNavigate();
  const location = useLocation();
  const { propertyId } = location.state = useParams();
  const [categories, setCategories] = useState([]);
  const [property, setProperty] = useState(null);
  const [selectedImage, setSelectedImage] = useState(0);
  const { userId, logout } = useContext(AuthContext);
  const [isSubscribed, setIsSubscribed] = useState(false);
    const [showSubscribeModal, setShowSubscribeModal] = useState(false);
      const [featureRequested, setFeatureRequested] = useState('');
      const [userPlan, setUserPlan] = useState(null);
const [loadingLocation, setLoadingLocation] = useState(false);
const [showSuccess, setShowSuccess] = useState(false);
const [showFailure, setShowFailure] = useState(false);
const [alertMessage, setAlertMessage] = useState("");


const handleCopyMobile = (mobile) => {
  if (!mobile) {
    setAlertMessage("Mobile number not available");
    setShowFailure(true);
    return;
  }

  navigator.clipboard.writeText(mobile)
    .then(() => {
      setAlertMessage(`Mobile number copied: ${mobile}`);
      setShowSuccess(true);
    })
    .catch(() => {
      setAlertMessage("Failed to copy mobile number");
      setShowFailure(true);
    });
};
        console.log('Location state:', location.state);
  console.log('Final propertyId:', propertyId);

      
  // Add these state variables at the top with your other states
  const [userActivities, setUserActivities] = useState([]);
  const [showLimitModal, setShowLimitModal] = useState(false);
  const handleImageClick = (image) => {
    setSelectedImage(image); // Update selected image
  };

useEffect(() => {
   const checkSubscription = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/Get-user-plan/${userId}/`);
      const userSubscriptions = response.data;
      const hasBuyerSubscription = Array.isArray(userSubscriptions) &&
        userSubscriptions.some(sub => sub.user_type === "Tenant");
      setIsSubscribed(hasBuyerSubscription);
    } catch (error) {
      console.error('Error checking subscription:', error);
      setIsSubscribed(false);
    }
  };


  if (userId) {
    checkSubscription();
  } else {
    console.log('No user ID, defaulting to non-subscribed state');
    setIsSubscribed(false);
    setUserPlan(null);
  }
}, [userId]);


// Add this useEffect to fetch user activities
useEffect(() => {
  const fetchUserActivities = async () => {
    if (!userId) {
      console.log('No userId - skipping activity fetch');
      return;
    }
    
    try {
      console.log(`Fetching activities for user ${userId}`);
      const response = await fetch(`${BASE_URL}/activities/`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const allActivities = await response.json();
      console.log('All activities from API:', allActivities);
      
      // Filter activities for the current user
      const filteredActivities = allActivities.filter(activity => 
        activity && activity.user_id !== undefined && 
        String(activity.user_id) === String(userId)
      );
      
      console.log('Filtered user activities:', filteredActivities);
      setUserActivities(filteredActivities);
    } catch (error) {
      console.error('Error fetching activities:', error);
      setUserActivities([]);
    }
  };

  fetchUserActivities();
}, [userId]);

// Enhanced property limit check with dynamic limits
const checkPropertyLimit = (currentPropertyId) => {
  if (!isSubscribed) {
    console.log('Non-subscriber - access denied');
    setFeatureRequested("Property Access");
    setShowSubscribeModal(true);
    return false;
  }

  // If unlimited access is granted
  if (userPlan?.no_of_properties_unlimited) {
    console.log('User has unlimited property access');
    return true;
  }

  const uniqueProperties = new Set(userActivities.map(a => a.property_id));
  const isExistingProperty = uniqueProperties.has(currentPropertyId);
  
  console.log(`User has accessed ${uniqueProperties.size} unique properties`);
  console.log(`Is current property already accessed? ${isExistingProperty}`);

  // Get the dynamic limit from user plan, default to 10 if not available
  const propertyLimit = userPlan?.no_of_properties || 10;
  
  if (uniqueProperties.size >= propertyLimit && !isExistingProperty) {
    console.log(`Property limit (${propertyLimit}) exceeded - showing limit modal`);
    setShowLimitModal(true);
    return false;
  }
  
  return true;
};

const handleLocationClick = () => {
  if (!isSubscribed) {
    setFeatureRequested("Location Access");
    setShowSubscribeModal(true);
    return;
  }

  if (!checkPropertyLimit(property.id)) {
    return;
  }

  setLoadingLocation(true); // 🔥 START SPINNER

  const logActivity = async () => {
    try {
      const response = await fetch(`${BASE_URL}/activities/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user_id: userId,
          property_id: property.id,
          activity_type: "Location",
          property_by: property.owner
        })
      });

      if (!response.ok) throw new Error('Failed to log location activity');

      const newActivity = await response.json();
      setUserActivities(prev => [...prev, newActivity]);
    } catch (err) {
      console.error(err);
    }
  };

  const openLocation = () => {
    const openMaps = (url) => {
      window.open(url, '_blank');
      setLoadingLocation(false); // 🔥 STOP SPINNER
    };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;

          if (property?.lat && property?.long) {
            openMaps(
              `https://www.google.com/maps/dir/?api=1&origin=${latitude},${longitude}&destination=${property.lat},${property.long}`
            );
          } else if (property?.loc) {
            openMaps(
              `https://www.google.com/maps/search/?query=${encodeURIComponent(property.loc)}`
            );
          }
        },
        () => {
          if (property?.lat && property?.long) {
            openMaps(`https://www.google.com/maps/?q=${property.lat},${property.long}`);
          } else if (property?.loc) {
            openMaps(
              `https://www.google.com/maps/search/?query=${encodeURIComponent(property.loc)}`
            );
          }
        }
      );
    } else {
      if (property?.lat && property?.long) {
        openMaps(`https://www.google.com/maps/?q=${property.lat},${property.long}`);
      } else if (property?.loc) {
        openMaps(
          `https://www.google.com/maps/search/?query=${encodeURIComponent(property.loc)}`
        );
      }
    }
  };

  logActivity().then(openLocation);
};

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch categories first
        const categoriesRes = await axios.get(`${BASE_URL}/property-category/`);
        setCategories(categoriesRes.data);
        
        // Then fetch property if propertyId exists
        if (propertyId) {
          const propertyRes = await axios.get(`${BASE_URL}/property/${propertyId}/`);
          setProperty(propertyRes.data);
        }
      } catch (err) {
        console.error('Failed to fetch data:', err);
      }
    };

    fetchData();
  }, [propertyId]);

  if (!property) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Typography>Loading property...</Typography>
      </Box>
    );
  }

  // Find the category that matches the property's category_id
  const propertyCategory = categories.find(cat => cat.category_id == property.category_id);
  const categoryName = propertyCategory ? propertyCategory.category : property.type;

  const {
    property_images = [],property_name, building_image,
    type, price, location: loc,lat,long,
    site_area, buildup_area,no_of_flores,
    facing, roadwidth, list, length, width,
    nearby, created_at, bedrooms_count,
    bathrooms_count, parking, balcony, max_acres
  } = property;

  const images = property_images.length > 0 
    ? property_images.map(img => `${BASE_URL}${img.image}`)
    : [buildingImage];

  return (
    <Box sx={{ width: '100vw', minHeight: '100vh',marginBottom:'10px', backgroundColor: 'rgb(239, 231, 221)', pb: 10 }}>
      {/* Header */}
      <Box sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        bgcolor: 'rgb(49, 48, 49)',
        color: 'white',
        p: 2,
        display: 'flex',
        alignItems: 'center',
        
      }}>
        <IconButton onClick={() => navigate(-1)} sx={{ color: 'white', mr: 1 }}>
          <ArrowBackIosNewIcon />
        </IconButton>
        <Typography variant="h6" fontWeight="bold">
        {categoryName?.replace(/"/g, '')|| 'Property Type'} 
        </Typography>
      </Box>

      {/* Property Content */}
      <Box sx={{ pt: '80px', px: 2 }}>
  <Card
  sx={{
    borderRadius: '20px',
    background: 'linear-gradient(135deg, #ffffff 0%,rgb(248, 248, 248) 100%)',
    boxShadow: 5,
    overflow: 'hidden',
  }}
>
<Box
  sx={{
    width: '100%',
    height: '200px',
    overflow: 'hidden',
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
    position: 'relative',

    '& .carousel-root': { height: '100% !important', width: '100% !important' },
    '& .carousel': { height: '100% !important', width: '100% !important' },
    '& .carousel-slider': { height: '100% !important', width: '100% !important' },
    '& .slider-wrapper': { height: '100% !important', width: '100% !important' },
    '& .slider': { height: '100% !important', width: '100% !important' },
    '& .slide': { height: '100% !important', minWidth: '100% !important' },
    '& .slide > div': { 
      height: '100% !important', 
      width: '100% !important',
      position: 'relative !important',  // ✅ THIS was missing — fixes blur layer
    },
  }}
>
  {images.length > 1 ? (
    <Carousel
      selectedItem={images.indexOf(selectedImage)}
      showThumbs={false}
      showArrows={false}
      autoPlay
      infiniteLoop
      interval={3000}
      showIndicators
      showStatus={false}
      swipeable
      emulateTouch
      stopOnHover
      transitionTime={600}
      useKeyboardArrows
    >
    {images.map((image, index) => (
  <Box
    key={index}
    sx={{
      width: '100%',
      height: '200px',
      position: 'relative',
      overflow: 'hidden',
      display: 'block',
    }}
  >
    {/* Blurred background */}
    <Box
      component="img"
      src={image}
      aria-hidden="true"
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%) scale(1.3)',
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        filter: 'blur(16px)',
        opacity: 0.7,
        zIndex: 0,
      }}
    />

    {/* Main image */}
    <Box
      component="img"
      src={image}
      alt="Property"
      loading="lazy"
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        zIndex: 1,
      }}
    />

    {/* ✅ ADD THIS WATERMARK */}
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography
        sx={{
          textAlign: 'center',
          fontSize: '12px',
          fontWeight: 'bold',
          color: 'rgba(255, 255, 255, 0.54)',
          whiteSpace: 'nowrap',
        }}
      >
        PROPERTY PINCODER
      </Typography>
    </Box>
  </Box>
))}
    </Carousel>
  ) : (
    <Box
      sx={{
        width: '100%',
        height: '200px',
        position: 'relative',
        overflow: 'hidden',
        borderTopLeftRadius: '20px',
        borderTopRightRadius: '20px',
      }}
    >
      {/* ✅ Blurred background */}
      <Box
        component="img"
        src={images[0]}
        aria-hidden="true"
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%) scale(1.3)',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          filter: 'blur(16px)',
          opacity: 0.7,
          zIndex: 0,
        }}
      />
      {/* ✅ Main image */}
      <Box
        component="img"
        src={images[0]}
        alt="Property"
        loading="lazy"
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          zIndex: 1,
        }}
      />
      {/* ✅ Watermark Overlay */}
<Box
  sx={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}
>
  <Typography
    sx={{
      position: 'absolute',
   textAlign:'center',
      fontSize: '12px',
      fontWeight: 'bold',
      color: 'rgba(255, 255, 255, 0.54)', // 👈 transparent
      whiteSpace: 'nowrap',
    }}
  >
    PROPERTY PINCODER
  </Typography>


</Box>
    </Box>
  )}
</Box>

    
{/* Thumbnail Images */}
<Container sx={{ mt: 3 }}>
  <Box
    sx={{
      display: 'flex',
      overflowX: 'auto',
      gap: 2,
      pb: 1,
      padding:'2%',
      '&::-webkit-scrollbar': { display: 'none' },
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
    }}
  >
    {images.map((image, index) => (
      <Box
        key={index}
        onClick={() => handleImageClick(image)}
        sx={{
          width: '30%',
          minWidth: '30%',
          aspectRatio: '4 / 3',
          borderRadius: '12px',
          overflow: 'hidden',
          position: 'relative',
          cursor: 'pointer',
          boxShadow:
            selectedImage === image
              ? '0px 4px 20px rgba(0, 0, 0, 0.3)'
              : '0px 2px 8px rgba(0, 0, 0, 0.1)',
          transform: selectedImage === image ? 'scale(1.02)' : 'scale(1)',
          transition: 'all 0.4s ease',
          border:
            selectedImage === image
              ? '2px solid #1976d2'
              : '2px solid transparent',
          flexShrink: 0,
          '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: '0px 6px 18px rgba(0, 0, 0, 0.2)',
          },
        }}
      >
        <Box
          component="img"
          src={image}
          alt={`Thumbnail ${index + 1}`}
          loading="lazy"
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </Box>
    ))}
  </Box>
</Container>


         <CardContent>
                              <Typography fontWeight="bold" fontSize="18px">
                                {categoryName?.replace(/"/g, '')} - {property.property_name || 'Property Type'}
                              </Typography>
 <Grid
   item
   sx={{
     display: 'flex',
     flexDirection: 'column',
     mt: 1,
     gap: 0.5,
     mb:0.3
   }}
 >
   {/* TOP ROW */}
 <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' ,mb:'5px'}}>
   
  <Box sx={{ width: 32, display: 'flex', alignItems: 'center' }}>
    <Tooltip title="Copy mobile number">
        <IconButton
              size="small"
              onClick={() => handleCopyMobile(property.mobile_no)}
              sx={{
                color: 'success.main',
                p: 0, // remove extra padding
                 gap: '4px',
                '&:hover': { backgroundColor: 'rgba(76, 175, 80, 0.1)' },
              }}
            >
              <CallIcon sx={{ fontSize: '19px' }} />
               <span style={{ fontSize: '14px' }}>Call</span>
            </IconButton>
    </Tooltip>
  </Box>


<Typography
  fontWeight="bold"
  fontSize="12px"
  color="rgb(240, 65, 30)"
  sx={{ whiteSpace: 'nowrap', display: 'flex', alignItems: 'center' }}
>
  {property.price ? (
    <>
      <span style={{ fontSize: '15px', marginRight: '2px' }}>₹</span>

      <span>
        {property.price.toLocaleString('en-IN')}
      </span>
    </>
  ) : (
    'NA'
  )}
</Typography>
 </Box>
 
 {/* BOTTOM ROW */}
 <Typography
   variant="caption"
   color="text.secondary"
   sx={{
     display: 'flex',
     alignItems: 'flex-start',
     gap: 0.2,
   }}
 >
   <Box sx={{ width: 32, display: 'flex', alignItems: 'flex-start' }}>
     {loadingLocation ? (
       <CircularProgress size={14} />
     ) : (
       <LocationOnIcon
         onClick={handleLocationClick}
         sx={{
           fontSize: '18px',
           color: 'primary.main',
           cursor: 'pointer',
         }}
       />
     )}
   </Box>
 
   <span>
     {property.location || 'Not Specified'}
   </span>
 </Typography>
 
 
 
 </Grid>
 
   <Box sx={{
               display: 'flex',
               justifyContent: 'space-between',
               bgcolor: '#ede7f6',
               borderRadius: 2,
               p: 2,
               mb: 2,
             }}>
   <Box sx={{ textAlign: 'center', flex: 1 }}>
   <Typography fontWeight="bold" color="primary">
     {property.site_area || property.max_acres
       ? (() => {
           const value = property.site_area || property.max_acres;
           const unitRaw = property.units || '';
           const unit = unitRaw.toLowerCase();
 
           // Acres & Gunta → show as it is
           if (['acre', 'acres', 'gunta', 'guntas'].includes(unit)) {
             return `${value} ${unitRaw}`;
           }
 
           // Other units → add "Sq" before unit
           return `${value}  ${unitRaw || 'ft'}`;
         })()
       : 'NA'}
   </Typography>
 
   <Typography variant="caption" color="text.secondary">
     Site Area
   </Typography>
 </Box>
               <Box sx={{ textAlign: 'center', flex: 1 }}>
                 <Typography fontWeight="bold" color="primary">
                   {property.roadwidth || 'NA'} ft
                 </Typography>
                 <Typography variant="caption" color="text.secondary">
                   Road Width
                 </Typography>
               </Box>
               <Box sx={{ textAlign: 'center', flex: 1 }}>
                 <Typography fontWeight="bold" color="primary">
                   {property.facing?.replace(/"/g, '') || 'NA'}
                 </Typography>
                 <Typography variant="caption" color="text.secondary">
                   Facing
                 </Typography>
               </Box>
             </Box>

            {/* Nearby
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
              Nearby:
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 3 }}>
              <Chip
                label={nearby?.replace(/"/g, '') || 'Not Available'}
                sx={{
                  bgcolor: 'rgb(211, 135, 173)',
                  color: 'rgb(35, 35, 36)',
                  fontWeight: 'bold',
                  fontSize: '13px',
                }}
              />
            </Box> */}

            {/* Overview */}
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
              Overview:
            </Typography>
           
            <Box sx={{
  border: '2px solid #424242',
  borderRadius: 2,
  overflow: 'hidden',
}}>
  {[
    [
      { icon: <AccessTimeIcon fontSize="small" />, title: 'Immediately', subtitle: 'Available From' },
      // { icon: <BedIcon fontSize="small" />, title: `${bedrooms_count || '2'} Bedroom${bedrooms_count !== 1 ? 's' : ''}`, },
      { icon: <CalendarTodayIcon fontSize="small" />, title: created_at ? new Date(created_at).toLocaleDateString('en-IN') : 'NA', subtitle: 'Posted on' },
    ],
    // [
    //   { icon: <BathtubIcon fontSize="small" />, title: `${bathrooms_count || '3'} Bathroom${bathrooms_count !== 1 ? 's' : ''}`,  },
    //   { icon: <AccessTimeIcon fontSize="small" />, title: 'Immediately', subtitle: 'Available From' },
    // ],
    // [
    //   { icon: <BalconyIcon fontSize="small" />, title: balcony ? 'Available' : 'Yes', subtitle: 'Balcony' },
    //   { icon: <HomeWorkIcon fontSize="small" />, title: type?.replace(/"/g, '') || 'NA', subtitle: 'Property Type' },
    // ],
    // [
    //   { icon: <DirectionsCarIcon fontSize="small" />, title: parking ? 'Available' : 'NA', subtitle: 'Parking' },
    //   { icon: <PowerIcon fontSize="small" />, title: 'None', subtitle: 'Power Backup' },
    // ],
  ].map((row, rowIndex) => (
    <Box key={rowIndex} sx={{ display: 'flex', width: '100%' }}>
      {row.map((item, colIndex) => (
        <Box
          key={colIndex}
          sx={{
            flex: '0 0 50%',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            p: 1.5, // Slightly reduced padding
            boxSizing: 'border-box',
            borderRight: colIndex == 0 ? '1px solid #9e9e9e' : 'none',
            borderBottom: rowIndex < 3 ? '1px solid #9e9e9e' : 'none',
            minWidth: 0,
          }}
        >
          <Box sx={{ 
            color: 'rgb(50, 47, 52)', 
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
          }}>
            {item.icon}
          </Box>
          <Box sx={{ minWidth: 0, overflow: 'hidden' }}>
            <Typography 
              fontWeight={500} // Slightly reduced weight
              fontSize="0.875rem" // 14px instead of 15px
              sx={{ 
                whiteSpace: 'normal', 
                wordBreak: 'break-word',
                lineHeight: 1.3
              }}
            >
              {item.title}
            </Typography>
            <Typography 
              variant="caption" 
              color="text.secondary" 
              fontSize="0.75rem" // 12px
              sx={{ 
                whiteSpace: 'normal', 
                wordBreak: 'break-word',
                lineHeight: 1.3
              }}
            >
              {item.subtitle}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  ))}
</Box>
            {/* Final Info */}
            <Box sx={{ mt: 3, borderTop: '1px dashed #d1c4e9', pt: 2 }}>
              {[
                ['Built Up Area', `${buildup_area || 'NA'} Sq.ft`, <CropSquareOutlinedIcon />],
                ['No .of Cars Parking', parking?.replace(/"/g, '') || 'NA', <DirectionsCarIcon />],
                ['Floor', `${no_of_flores || 'NA'}`, <LayersOutlinedIcon />],
                // ['Gated Security', 'No', <SecurityOutlinedIcon />],
              ].map(([label, value, icon], i) => (
                <Box
                  key={i}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    mb: i !== 3 ? 1.5 : 0,
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', color: 'rgb(52, 50, 53)' }}>
                    {icon}
                    <Typography fontSize={14} sx={{ ml: 1 }} color="text.primary">
                      {label}
                    </Typography>
                  </Box>
                  <Typography fontWeight={500} color="text.primary" fontSize={14}>
                    {value}
                  </Typography>
                </Box>
              ))}
            
   <Box
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mt: 2
  }}
>
  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    <CropSquareOutlinedIcon sx={{ color: "#444" }} />
    <Typography sx={{ fontSize: "0.9rem" }}>
      Length*Width
    </Typography>
  </Box>
 <Typography sx={{ fontSize: "0.9rem", fontWeight: 500 }}>
  {property.length && property.width
    ? (() => {
        const unitRaw = property.units || "";
        const unit = unitRaw.toLowerCase();

        // Acres / Gunta → as it is
        if (['acre', 'acres', 'gunta', 'guntas'].includes(unit)) {
          return `${property.length} * ${property.width} ${unitRaw}`;
        }

        // Others → add Sq before unit
        return `${property.length} * ${property.width} Sq ${unitRaw || 'ft'}`;
      })()
    : "NA"}
</Typography>
</Box>

<Box
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mt: 2
  }}
>
  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    <SecurityOutlinedIcon sx={{ color: "#444" }} />
    <Typography sx={{ fontSize: "0.9rem" }}>
      Average Price
    </Typography>
  </Box>
 <Typography sx={{ fontSize: "0.9rem", fontWeight: 500 }}>
  {property.site_area || property.max_acres && property.price
    ? (() => {
        const area = parseFloat(property.site_area || property.max_acres);
        const avgPrice = parseFloat(property.price) / area;

        const unitRaw = property.units || "";
        const unit = unitRaw.toLowerCase();

        // Acres / Gunta → as it is
        if (['acre', 'acres', 'gunta', 'guntas'].includes(unit)) {
          return `₹${avgPrice.toFixed(2)} / ${unitRaw}`;
        }

        // Others → add Sq before unit
        return `₹${avgPrice.toFixed(2)} /  ${unitRaw || 'ft'}`;
      })()
    : "NA"}
</Typography>
</Box>  
            </Box>
          </CardContent>
        </Card>
      </Box>
      {showSubscribeModal && (
                    <Box sx={{
                      position: 'fixed',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: 'rgba(0,0,0,0.5)',
                      zIndex: 9999,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}>
                      <Paper sx={{ padding: 3, maxWidth: 300, textAlign: 'center' }}>
                        <Typography variant="h6" gutterBottom>
                          Subscription Required
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                          Please subscribe to use the {featureRequested} feature.
                        </Typography>
                        <Button 
                          variant="contained" 
                          color="primary"
                          onClick={() => setShowSubscribeModal(false)}
                        >
                          OK
                        </Button>
                      </Paper>
                    </Box>
                  )}
      
        
      {/* Limit Exceeded Modal */}
      {showLimitModal && (
        <Box sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 9999,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <Paper sx={{ padding: 3, maxWidth: 300, textAlign: 'center' }}>
            <Typography variant="h6" gutterBottom>
              Limit Exceeded
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              {userPlan?.no_of_properties_unlimited 
                ? "You have unlimited access to properties."
                : `You've reached your limit of ${userPlan?.no_of_properties || 10} properties. 
                   Please upgrade your subscription plan for more.`
              }
            </Typography>
            <Button 
              variant="contained" 
              color="primary"
              onClick={() => setShowLimitModal(false)}
            >
              OK
            </Button>
          </Paper>
        </Box>
      )}
{showSuccess && (
  <CopySuccessAlert
    message={alertMessage}
    onClose={() => {
      setShowSuccess(false);
      setAlertMessage(""); // Clear message when closing
    }}
  />
)}

{showFailure && (
  <CopyFailureAlert
    message={alertMessage}
    onClose={() => {
      console.log("Closing failure alert");
      setShowFailure(false);
      setAlertMessage("");
    }}
  />
)}

      {/* Bottom Navigation */}
      <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, }} elevation={3}>
        
        <CustomBottomNav />
      </Paper>
    </Box>
  );
};

export default Lease_description;